import { render, staticRenderFns } from "./InstanceModifyOpinion.vue?vue&type=template&id=3c3aadf9&scoped=true&"
import script from "./InstanceModifyOpinion.vue?vue&type=script&lang=js&"
export * from "./InstanceModifyOpinion.vue?vue&type=script&lang=js&"
import style0 from "./InstanceModifyOpinion.vue?vue&type=style&index=0&id=3c3aadf9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3aadf9",
  null
  
)

export default component.exports